
import React from "react";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
import { Button } from "@material-ui/core";
window.html2canvas = html2canvas;

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
  const downloadPdfDocument = async () => {

  

    const input = document.getElementById(rootElementId);
    if (!input) return;

   // Find and temporarily show print-only elements
  const printOnlyElements = input.querySelectorAll('.print-only-footer');
  printOnlyElements.forEach(el => {
    el.style.display = 'block';
  });

    const images = input.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map((img) => {
        if (!img.complete) {
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }
        return Promise.resolve();
      })
    );

    html2canvas(input, { useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 10;

      // FIXED: Only add the image once per page
      pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Only add additional pages if there's remaining content
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${downloadFileName}.pdf`);
    });

      printOnlyElements.forEach(el => {
      el.style.display = 'none';
    });
  };

  return (
    <Button
      onClick={downloadPdfDocument}
      style={{
        padding: "10px 20px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
      }}
    >
      Download PDF
    </Button>
  );
};

export default GenericPdfDownloader;